import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Conflegrate",
    "spell_fire_fireball",
    [
      "Inflicts the target afflicted by Immolate, dealing 249 to 316 damage, consuming the Immolate spell.",
    ],
    1,
    [[]],
    [{ x: 5, y: 1 }],
    null,
    "165 Mana",
    "30 yd range",
    "Instant",
    "10 sec cooldown",
  ),
  null,
  null,
];

export default tier7;
